import React from "react";
import { Form, Message } from "semantic-ui-react";
import Flatpickr from "react-flatpickr";

const dateTimePicker = {
  enableTime: true,
  dateFormat: "Y/m/d H:i:S",
  disableMobile: "true"
};

function General(props) {
  const { campaigns, values, valid } = props;
  const rules = {
    title: "required",
    start_at: "required|date",
    end_at: "required|date|after:start_at",
  };
  const customMessages = {
    "after.end_at": "The End Date must come after the Start Date",
    "required.title": "Title is required",
    "required.start_at": "Start Date is required",
    "required.end_at": "End Date is required"
  };
  props.setRules(rules, customMessages);
  return (
    <Form size="large" error={valid.errorCount > 0}>
      <Message
        error
        content={Object.keys(valid.errors.all()).map((item, key) => {
          return (
            <span key={key}>
              {valid.errors.first(item)}
              <br />
            </span>
          );
        })}
      />
      <Form.Input
        label="Title"
        name="event.title"
        value={values.title}
        required
        error={valid.errors.has("title")}
        onChange={props.handleChange}
      />
      <Form.Group widths="equal">
        <Form.Field error={valid.errors.has("start_at")} required>
          <label>Start Date</label>
          <Flatpickr
            name="event.start_at"
            value={values.start_at || ""}
            options={dateTimePicker}
            onChange={(_, str, b) =>
              props.handleChange(b.element, {
                name: "event.start_at",
                value: str
              })
            }
            onClose={(_, str, b) =>
              props.handleChange(b.element, {
                name: "event.start_at",
                value: str
              })
            }
          />
        </Form.Field>
        <Form.Field error={valid.errors.has("end_at")} required>
          <label>End Date</label>
          <Flatpickr
            name="event.end_at"
            value={values.end_at || ""}
            options={dateTimePicker}
            onChange={(_, str, b) =>
              props.handleChange(b.element, {
                name: "event.end_at",
                value: str
              })
            }
            onClose={(_, str, b) =>
              props.handleChange(b.element, {
                name: "event.end_at",
                value: str
              })
            }
          />
        </Form.Field>
      </Form.Group>
      <Form.Field>
        <label>Live Event?</label>
        <Form.Radio
          toggle
          size="large"
          label={+values.is_test === 1 ? "This is a test event, it will not be listed in reports or winner lists" : "This is a live event"}
          value="1"
          name="event.is_test"
          checked={+values.is_test === 0}
          onChange={props.handleChange}
          className="radioToggleBtn"
        />
      </Form.Field>
      <Form.Field>
        <label>Hide Event?</label>
        <Form.Radio
          toggle
          size="large"
          label={+values.is_hidden === 1 ? "This is now a hidden event, it will not be listed in reports or winner lists" : "This event is displayed in the Event List"}
          value="1"
          name="event.is_hidden"
          checked={+values.is_hidden === 1}
          onChange={props.handleChange}
          className="radioToggleBtn"
        />
      </Form.Field>
      <Form.Field>
        <label>Campaigns</label>
        {campaigns.map((v, k) => (
          <Form.Checkbox
            key={v.id}
            label={v.text}
            value={v.value}
            name="event.campaigns"
            checked={values.campaigns.indexOf(v.value) > -1}
            onChange={props.handleCampaigns}
          />
        ))}
      </Form.Field>
      <Form.Group inline>
        <Form.Button
          type="button"
          primary
          size="large"
          onClick={() => props.handleStep("games")}
        >
          Save And Continue{" "}
        </Form.Button>
      </Form.Group>
    </Form>
  );
}

export default General;
